import { useEffect, useRef, useState } from 'react'
import { FavouriteStore } from 'src/components/sections/Store/typings'
import { Days, PickupPoint } from '../StorePickerSidebar'

export const getIsStoreOpen = (storeData: PickupPoint) => {
  const minutes = new Date().getHours() * 60 + new Date().getMinutes()
  const weekday = new Date()
    .toLocaleDateString('en-US', {
      weekday: 'long',
    })
    .toLowerCase() as Days
  const targetRanges = storeData.data.hours[weekday].openIntervals
  const isOpen = targetRanges.some((range) => {
    const [sh, sm] = range.start.split(':').map(Number)
    const [eh, em] = range.end.split(':').map(Number)
    return minutes >= sh * 60 + sm && minutes <= eh * 60 + em
  })
  if (isOpen) {
    return { label: 'Aperto', color: 'text-green-700' }
  }
  return { label: 'Chiuso', color: 'text-orange-500' }
}

export const getStoreName = (
  store: PickupPoint | FavouriteStore,
  section?: 'summary' | 'mobile'
) => {
  // If coming from Yext in sidebar
  if ('data' in store) {
    return !section
      ? `Arcaplanet - ${store.data.address.city.toUpperCase()}, ${store.data.address.line1.toUpperCase()}`
      : section === 'mobile'
      ? `${store.data.address.city}, ${store.data.address.line1}`
      : `Arcaplanet - ${store.data.address.line1.toUpperCase()}`
  }

  // if coming from SF in useEffect on load/login
  // if (store?.address?.number) {
  //   let street = store.address.street
  //   const hasAlreadyNumber = store.address.street.includes(store.address.number)
  //   if (!hasAlreadyNumber) {
  //     street = `${store.address.street}, ${store.address.number}`
  //   }
  //   return !section
  //     ? `Arcaplanet - ${store.address.city.toUpperCase()}, ${street.toUpperCase()}`
  //     : section === 'mobile'
  //     ? `${store.address.city}, ${street}`
  //     : `Arcaplanet - ${street.toUpperCase()}`
  // }

  // if coming from saving in PLP or PDP via modal
  return !section
    ? `Arcaplanet - ${store?.address?.city.toUpperCase()}, ${store?.address?.street.toUpperCase()}`
    : section === 'mobile'
    ? `${store?.address?.city}, ${store?.address?.street}`
    : `Arcaplanet - ${store?.address?.street.toUpperCase()}`
}

export const getStoreAddress = (store: PickupPoint | FavouriteStore) => {
  if ('data' in store) {
    return `${store.data.address.line1}, ${store.data.address.city}, ${store.data.address.region} - ${store.data.address.postalCode}`
  }

  // if coming from SF
  // if (store?.address?.number) {
  //   let street = store.address.street
  //   const hasAlreadyNumber = store.address.street.includes(store.address.number)
  //   if (!hasAlreadyNumber) {
  //     street = `${store.address.street}, ${store.address.number}`
  //   }
  //   return `${street}, ${store?.address?.city}, ${store?.address?.state} - ${store?.postalCode}`
  // }

  // if coming from saving in PLP or PDP
  return `${store?.address?.street}, ${store?.address?.city}, ${store?.address?.state} - ${store?.postalCode}`
}

export const useSlidingAnimation = (
  isVisible: boolean,
  delay: number = 150
) => {
  const [isMounted, setIsMounted] = useState(false)
  const [shouldRender, setShouldRender] = useState(false)
  const timer = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    if (isVisible) {
      setShouldRender(true)
      requestAnimationFrame(() => setIsMounted(true))
    } else if (!isVisible && shouldRender) {
      setIsMounted(false)
      timer.current = setTimeout(() => {
        setShouldRender(false)
      }, delay)
    }

    return () => clearTimeout(timer.current!)
  }, [isVisible, delay, shouldRender])

  const className = isMounted ? 'translate-x-0' : '-translate-x-full'

  return { shouldRender, className }
}
